import { ReduxPromiseAction } from 'typedRedux/actionTypes'

export function clearNotification() {
  return {
    type: 'NOTIFICATION_CLEAR',
  }
}

export function sendNotification(
  message: string,
  style?: 'success' | 'info' | 'error' | 'warning',
  timeout?: number,
): ReduxPromiseAction {
  return (dispatch) => {
    const dispatchPromise = dispatch({
      type: 'NOTIFICATION_SEND',
      meta: { style },
      payload: message,
    })

    if (timeout) {
      const timer = (window as any).notificationTimer
      window.clearTimeout(timer)
      ;(window as any).notificationTimer = setTimeout(
        () => dispatch(clearNotification()),
        timeout,
      )
    }

    return dispatchPromise
  }
}
